module.exports = __webpack_public_path__ + "img/partner-list-9.32ab8bf4.png";